import React from 'react';
import { Layout } from 'antd';
import { 
  ArrowLeftOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useClientAdmin } from '../../context/ClientAdminContext';

const { Content, Header } = Layout;

const ClientPortal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clientAdmin } = useClientAdmin();

  // Determine which tabs to show based on applicationForm
  const showRockNMalta = clientAdmin?.applicationForm === 'RockNMalta';
  const showGhannejja = clientAdmin?.applicationForm === 'Għannejja Ġodda';

  return (
    <Layout style={{ minHeight: '100vh', background: '#fafafa' }}>
      <Header style={{ padding: '0 20px', background: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', minWidth: '200px' }}>
            <img
              src="/images/FM_Logo.png"
              alt="Festivals Malta"
              onClick={() => navigate('/')}
              style={{
                height: '36px',
                cursor: 'pointer',
                objectFit: 'contain',
                marginRight: '20px'
              }}
            />
            {showRockNMalta && (
              <span 
                style={{ 
                  color: '#262626', 
                  fontSize: 'clamp(12px, 3vw, 16px)', 
                  cursor: 'pointer',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s'
                }}
                onClick={() => navigate('/client-portal/rocknmalta')}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                RockNMalta
              </span>
            )}
            {showGhannejja && (
              <span 
                style={{ 
                  color: '#262626', 
                  fontSize: 'clamp(12px, 3vw, 16px)', 
                  cursor: 'pointer',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s'
                }}
                onClick={() => navigate('/client-portal/ghannejja')}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Għannejja Ġodda 2026
              </span>
            )}
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            {/* Empty space for future buttons if needed */}
          </div>
        </div>
      </Header>

      <Content style={{ padding: 'clamp(20px, 5vw, 48px)' }}>
        <div style={{ 
          textAlign: 'center', 
          padding: 'clamp(40px, 8vw, 80px) 20px',
          background: 'white',
          borderRadius: '8px',
          border: '1px solid #f0f0f0',
          margin: '0 auto',
          maxWidth: '600px'
        }}>
          <CalendarOutlined style={{ fontSize: 'clamp(40px, 10vw, 64px)', color: '#1890ff', marginBottom: '24px' }} />
          <h1 style={{ 
            color: '#262626', 
            marginBottom: '16px',
            fontWeight: 300,
            fontSize: 'clamp(24px, 6vw, 32px)'
          }}>
            Welcome to Client Portal
          </h1>
          {clientAdmin && (
            <div style={{
              background: '#e6f7ff',
              border: '1px solid #91d5ff',
              borderRadius: '4px',
              padding: '12px 16px',
              marginBottom: '16px'
            }}>
              <p style={{ margin: 0, color: '#1890ff', fontWeight: 500 }}>
                User logged in: {clientAdmin.name} ({clientAdmin.applicationForm || 'No form assigned'})
              </p>
            </div>
          )}
          <p style={{ 
            color: '#666', 
            fontSize: 'clamp(14px, 4vw, 16px)',
            margin: 0
          }}>
            Select an application form from the menu above to get started
          </p>
        </div>
      </Content>
    </Layout>
  );
};

export default ClientPortal;